import React from "react";
import { Link } from "react-router-dom";
import './styles.css'

const Header = () =>
{
    return(
        <>
        
        
           <nav style={{backgroundColor:'#141010',padding:'.8rem'}}  >
               
                
                    <div className="m-3 p-3 d-flex justify-content-start">
                        <h1 className="name text-light mt-3">Aishwary Patle</h1>
                    </div>
                    
                    
                    <div className="links d-flex justify-content-end text-light">
                       <Link className="navBtn " to='/'>Home</Link>
                       <Link className="navBtn" to='/projects'>Projects</Link>
                       <Link className="navBtn" to='/blog'>Blogs</Link>
                    </div>
                
               
            </nav>
        
        </>
    )
}


export default Header